module.exports = __webpack_public_path__ + "img/tong1.6bcf0e8c.png";